import React, { useState } from "react";
import { useAuth } from "../../../../hooks/useAuth";
import { createRefundRequestAPI } from "../../../../api/index"; // ✅ API import 추가
import "./RefundRequest.css";

const RefundRequest = () => {
  const { user } = useAuth();
  const [amount, setAmount] = useState("");
  const [contact, setContact] = useState("");
  const [bankName, setBankName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false); // ✅ 제출 상태 추가

  // 사용자 예치금 잔액 (user.deposit 사용)
  const userBalance = user?.deposit || 0;

  const handleAmountChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setAmount(value);
  };

  const handleAmountBlur = () => {
    // 필드가 비어있으면 아무것도 하지 않고 종료 (탭 이동 시 팝업 방지)
    if (!amount) {
      return;
    }

    // 1. 보유 예치금이 5만원 미만인 경우, 팝업 후 0으로 설정
    if (userBalance < 50000) {
      alert("예치금 잔액이 50,000원 미만으로 환불 신청이 불가합니다.");
      setAmount("0");
      return;
    }

    // --- 아래는 예치금이 5만원 이상일 경우의 기존 포맷팅 로직 ---
    let numericAmount = parseInt(amount, 10);

    if (isNaN(numericAmount)) {
      setAmount(""); // 비어있으면 ''으로 초기화
      return;
    }

    // 예치금 잔액보다 많이 입력했는지 확인
    if (numericAmount > userBalance) {
      alert(
        `환불 가능 금액(${userBalance.toLocaleString(
          "ko-KR"
        )}원)을 초과했습니다.`
      );
      numericAmount = userBalance;
    }

    // 최소 환불 금액 확인
    if (numericAmount < 50000) {
      alert("최소 환불 가능 금액은 50,000원입니다.");
      setAmount("50000");
      return;
    }

    // 5만원 단위로 내림 포맷팅
    const formatted = Math.floor(numericAmount / 50000) * 50000;
    setAmount(String(formatted));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 유효성 검사
    if (!amount || Number(amount) <= 0) {
      alert("환불 금액을 입력해주세요.");
      return;
    }

    if (!contact.trim()) {
      alert("연락처를 입력해주세요.");
      return;
    }

    if (!bankName.trim()) {
      alert("은행명을 입력해주세요.");
      return;
    }

    if (!accountNumber.trim()) {
      alert("계좌번호를 입력해주세요.");
      return;
    }

    // 예치금 잔액 확인
    if (Number(amount) > userBalance) {
      alert("환불 금액이 보유 예치금을 초과합니다.");
      return;
    }

    setIsSubmitting(true);

    try {
      const requestData = {
        web_member_id: user.id,
        amount: Number(amount),
        contact: contact,
        refund_bank: bankName,
        refund_bank_no: accountNumber,
      };

      await createRefundRequestAPI(requestData);

      alert("환불 신청이 완료되었습니다.");

      // 폼 초기화
      setAmount("");
      setContact("");
      setBankName("");
      setAccountNumber("");
    } catch (error) {
      console.error("❌ 환불 요청 실패:", error);
      const errorMessage =
        error.response?.data?.msg ||
        error.message ||
        "환불 요청에 실패했습니다.";
      alert(`환불 요청 실패: ${errorMessage}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form className="refund-request-form" onSubmit={handleSubmit}>
      <div className="form-row">
        <label className="form-field">
          <span className="label">환불 금액</span>
          <input
            type="text"
            className="input"
            value={amount}
            onChange={handleAmountChange}
            onBlur={handleAmountBlur}
          />
        </label>
        <label className="form-field">
          <span className="label">환불 받으실 분 연락처</span>
          <input
            type="text"
            className="input"
            placeholder="Enter"
            value={contact}
            onChange={(e) => setContact(e.target.value)}
          />
        </label>
        <label className="form-field">
          <span className="label">환불 받으실 은행</span>
          <input
            type="text"
            className="input"
            placeholder="Enter"
            value={bankName}
            onChange={(e) => setBankName(e.target.value)}
          />
        </label>
        <label className="form-field">
          <span className="label">환불 받으실 계좌번호</span>
          <input
            type="text"
            className="input"
            placeholder="Enter"
            value={accountNumber}
            onChange={(e) => setAccountNumber(e.target.value)}
          />
        </label>
      </div>
      <div className="actions">
        <button type="submit" className="submit-button" disabled={isSubmitting}>
          {isSubmitting ? "요청 중..." : "환불 요청"}
        </button>
      </div>
    </form>
  );
};

export default RefundRequest;
